<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(defineProps<{
	class?: HTMLAttributes['class']
	colspan?: number
}>(), {
	colspan: 1,
})

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})
</script>

<template>
	<ui-table-row>
		<ui-table-cell
			:class="
				cn(
					'p-4 whitespace-nowrap align-middle text-sm text-foreground',
					props.class,
				)
			"
			v-bind="delegatedProps"
		>
			<div class="flex items-center justify-center py-10">
				<slot />
			</div>
		</ui-table-cell>
	</ui-table-row>
</template>
